module.exports = __webpack_public_path__ + "static/media/services3.8fb17d84.png";